import { render, staticRenderFns } from "./SuccessLinkingModal.vue?vue&type=template&id=253ab322&scoped=true"
import script from "./SuccessLinkingModal.vue?vue&type=script&lang=js"
export * from "./SuccessLinkingModal.vue?vue&type=script&lang=js"
import style0 from "./SuccessLinkingModal.vue?vue&type=style&index=0&id=253ab322&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253ab322",
  null
  
)

export default component.exports